import {
  DetailsHeader,
  DetailsList,
  DetailsRow,
  Selection,
  SelectionMode,
} from 'office-ui-fabric-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SORTING_KEYS } from '../../../../constants/sortingKeys';
import { filterAndSortingKeys } from '../../../../utilities/filterAndSortingsUtil';

const listStyle = {
  root: {
    backgroundColor: '#FAFAFA',
  },
};

export const SubjectAreaList = ({
  subjectAreaItems,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  onSubjectAreaClick,
  onSubjectAreaSelect,
}) => {
  const { t: translator } = useTranslation();

  const onSubjectAreaClickCallback = (subjectAreaItem) => {
    onSubjectAreaClick && onSubjectAreaClick(subjectAreaItem.key);
  };

  const onSelectionChanged = () => {
    const [selection] = listSelection.getSelection();
    onSubjectAreaSelect && onSubjectAreaSelect(selection && selection.key);
  };

  const [listSelection] = useState(
    new Selection({
      onSelectionChanged: onSelectionChanged,
      selectionMode: SelectionMode.single,
    }),
  );

  const selectionKey =
    subjectAreaItems && subjectAreaItems.length
      ? subjectAreaItems
          .map((i) => i.key)
          .sort()
          .join('')
      : 'none';

  const sortingKey = filterAndSortingSelection[filterAndSortingKeys.sortingKey];

  return (
    <div className="changeHearingOwner-list">
      {
        <DetailsList
          items={subjectAreaItems}
          ariaLabelForSelectionColumn={translator(
            'ariaLabel.listSelectionColumn',
          )}
          ariaLabel={translator('ariaLabel.subjectAreaListLabel')}
          ariaLabelForSelectAllCheckbox={translator('ariaLabel.listSelectAll')}
          setKey={selectionKey}
          selection={listSelection}
          isCompactMode={false}
          columns={columns(sortingKey, translator)}
          onColumnHeaderClick={onColumnHeaderClick(
            sortingKey,
            filterAndSortingSelection,
            setFilterAndSortingSelection,
          )}
          onRenderDetailsHeader={(props) => {
            return (
              <DetailsHeader
                {...props}
                styles={listStyle}
                ariaLabel={translator('ariaLabel.listHeader')}
              />
            );
          }}
          onRenderRow={(props) => {
            return <DetailsRow tabIndex="0" {...props} styles={listStyle} />;
          }}
          compact={false}
          onItemInvoked={onSubjectAreaClickCallback}
        />
      }
    </div>
  );
};

const columns = (sortingKey, translator) => [
  {
    key: 'title',
    name: translator('hearingProperties.subjectArea'),
    ariaLabel: translator('hearingProperties.subjectArea'),
    fieldName: 'title',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 350,
    isSorted:
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL ||
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL_REVERSE,
    isSortedDescending: sortingKey === SORTING_KEYS.TITLEALPHABETICAL,
  },
  {
    key: 'status',
    name: translator('global.status'),
    ariaLabel: translator('global.status'),
    fieldName: 'status',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 110,
    isSorted:
      sortingKey === SORTING_KEYS.STATUS_ASC ||
      sortingKey === SORTING_KEYS.STATUS_DESC,
    isSortedDescending: sortingKey === SORTING_KEYS.STATUS_ASC,
  },
  {
    key: 'numberOfHearings',
    data: 'integer',
    name: translator('hearingProperties.numOfHearings'),
    ariaLabel: translator('hearingProperties.numOfHearings'),
    fieldName: 'numberOfHearings',
    isPadded: true,
    isResizable: false,
    minWidth: 140,
    isSorted:
      sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC ||
      sortingKey === SORTING_KEYS.NUMOFHEARINGS_DESC,
    isSortedDescending: sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC,
  },
];

const onColumnHeaderClick = (
  sortingKey,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
) => (_, col) => {
  let resultingSortingKey = null;

  if (col.key === 'title') {
    if (sortingKey === SORTING_KEYS.TITLEALPHABETICAL) {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL_REVERSE;
    } else {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL;
    }
  } else if (col.key === 'status') {
    if (sortingKey === SORTING_KEYS.STATUS_ASC) {
      resultingSortingKey = SORTING_KEYS.STATUS_DESC;
    } else {
      resultingSortingKey = SORTING_KEYS.STATUS_ASC;
    }
  } else if (col.key === 'numberOfHearings') {
    if (sortingKey === SORTING_KEYS.NUMOFHEARINGS_ASC) {
      resultingSortingKey = SORTING_KEYS.NUMOFHEARINGS_DESC;
    } else {
      resultingSortingKey = SORTING_KEYS.NUMOFHEARINGS_ASC;
    }
  }

  if (resultingSortingKey) {
    let currFilterAndSortingSelection = Object.assign(
      {},
      filterAndSortingSelection,
    );
    currFilterAndSortingSelection[
      filterAndSortingKeys.sortingKey
    ] = resultingSortingKey;
    setFilterAndSortingSelection(currFilterAndSortingSelection);
  }
};
